// import {
//   BrowserRouter as Router,
//   Routes,
//   Route,
// } from "react-router-dom";

import '@mantine/core/styles.css';
import './App.css'; // Make sure the file path is correct

// import ErrorBoundary from "./components/ErrorBoundary";
import { initReactI18next } from "react-i18next";
import i18nextBrowserLanguageDetector from "i18next-browser-languagedetector"
import i18next from "i18next";
// import LocalesImportPlugin from "./components/LocalesLazyImport";

import { SUPPORTED_LANGUAGES } from "./utils/const";
import React from "react";

import PageNotFound from "./pages/page404";
import { RouteRecord } from "vite-react-ssg";

const Home = React.lazy(() => import("./pages/Home"));
const Privacy = React.lazy(() => import('./pages/Privacy'));
const Contact = React.lazy(() => import('./pages/Contact'));

import { blogRoutes } from "./_blog/routes";
import ErrorBoundary from './components/ErrorBoundary';

i18next
  .use(initReactI18next)
  .use(i18nextBrowserLanguageDetector)
  .init({
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    ns: ['common'],
    detection: {
      order: ['path', 'sessionStorage', 'navigator'],
      caches: ['sessionStorage'],
      lookupFromPathIndex: 0
    },
    supportedLngs: SUPPORTED_LANGUAGES,
    saveMissing: true, // for missing key handler to fire
    missingKeyHandler: function (lng, ns, key, fallbackValue) {
      console.log("Missing:", key);
    }
  });


const staticPaths: RouteRecord[] = [
  { path: "", Component: Home },
  { path: "privacy", Component: Privacy },
  { path: "contact", Component: Contact },
  { path: "*", Component: PageNotFound }
]

let routes: RouteRecord[] = staticPaths.map(
  route => ["/"].map(
    (language) => (
      {path: language.concat(route.path!), Component: route.Component, ErrorBoundary: ErrorBoundary}
      )
    )
  ).flat()

routes = routes.concat(
  blogRoutes.map(
    ([url, Component]) => (
      {path: `${url}`, Component: Component, ErrorBoundary: ErrorBoundary} as RouteRecord)
    )
  );

// Modify the routes export to include a navigation handler
routes = routes.map(route => ({
  ...route,
  // Add this handler to force page reload on navigation
  beforeNavigate: () => {
    window.location.href = route.path;
    return false; // Prevent default client-side navigation
  }
}));

export default routes;